import EditorOverlayStateEnum from 'EditorOverlay/EditorOverlayConstants';
import isImagePopup from './isImagePopup';
import isRequestSignaturePopup from './isRequestSignaturePopup';

export default (popup, mode) => {
  switch (mode) {
    case EditorOverlayStateEnum.REQUEST_SIGNATURE:
    case EditorOverlayStateEnum.COMPOSE_REQUEST_FIELDS:
      return isRequestSignaturePopup(popup);
    case EditorOverlayStateEnum.COMPOSE_REQUEST_SIGNERS:
    case EditorOverlayStateEnum.COMPOSE_REQUEST_MESSAGE:
    case EditorOverlayStateEnum.LOCKED:
    case EditorOverlayStateEnum.REQUEST_SIGNATURE_FILL:
    case EditorOverlayStateEnum.REQUEST_SIGNATURE_WAIT:
    case EditorOverlayStateEnum.SENDER_SIGNING:
    case EditorOverlayStateEnum.VIEW:
      return false;
    case EditorOverlayStateEnum.SIGN:
      return isImagePopup(popup);
    default:
      return popup.draggable;
  }
};




// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isDraggable.jsx